import Typography, { type TypographyProps } from "@mui/material/Typography";

import { type Money } from "~/utilities/money";

export function LedgerAmount({
  amount,
  ...props
}: TypographyProps & { amount: Money }) {
  return (
    <Typography
      variant="body2"
      fontWeight="bold"
      color={amount.isNegative() ? "error.main" : undefined}
      {...props}
    >
      {amount.format()}
    </Typography>
  );
}
